function Unselect({ size }: { size: number }) {
	return (
		<svg width={size} height={size} viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="6.34375" cy="6" r="5.375" fill="#FAFAFA" stroke="#E7E7E7" stroke-width="1.25" />
		</svg>
	);
}

export default Unselect;
